import { render } from "./UIBrands.vue?vue&type=template&id=1980ffcd&scoped=true"
const script = {}

import "./UIBrands.vue?vue&type=style&index=0&id=1980ffcd&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1980ffcd"]])

export default __exports__